import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { IpcChannel, IpcV2Service } from 'src/app/services/ipc-v2.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnDestroy {

  logs = [];
  constructor(
    @Optional() public dialogRef: DialogRef<ErrorComponent>,
    @Optional() @Inject(DIALOG_DATA) public data: any,
    private readonly ipcV2: IpcV2Service
  ) {
    if(data ?? data[0]?.lines) {
      this.logs = data[0].lines;
    }
  }
  downloadLogs() {
    this.ipcV2.sendAndReceive(IpcChannel.DOWNLOAD_LOGS).subscribe();
  }

  clearLogs() {
    this.ipcV2.sendAndReceive(IpcChannel.CLEAR_LOGS).subscribe();
  }

  ngOnDestroy(): void {
      this.ipcV2.removeListener(IpcChannel.DOWNLOAD_LOGS);
      this.ipcV2.removeListener(IpcChannel.CLEAR_LOGS);
  }

}